import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const FALLBACK = "talleres presenciales";
const KEY = "vt-hero-phrase";

export const RotatingPhrase = () => {
  const [phrase, setPhrase] = useState(() => sessionStorage.getItem(KEY));

  useEffect(() => {
    if (phrase) return;
    api.get("/hero-phrases").then(({ data }) => {
      const list = data.phrases || [];
      const pick = list.length ? list[Math.floor(Math.random() * list.length)] : FALLBACK;
      sessionStorage.setItem(KEY, pick);
      setPhrase(pick);
    }).catch(() => setPhrase(FALLBACK));
  }, [phrase]);

  return (
    <span className={`inline-block transition-opacity duration-500 ${phrase ? "opacity-100" : "opacity-0"}`} data-testid="hero-rotating-phrase">
      {phrase || FALLBACK}
    </span>
  );
};
